import {useEffect,useState} from 'react';
import {api} from '../api';
import {BuildingImage} from './BuildingImage';
import {BuildingPhotoUpload} from './BuildingPhotoUpload';
import {useCapability} from './StaffSession';
import {withBuildingScope} from './building-scope';
import {ErrorState,State,reviewedApplicationError} from './State';
import './building-photo.css';
type Photo={documentId:string;versionId:string;title:string};
type Result={building:string;image:Photo|null};
type Resource={building:string;data?:Result;error?:unknown};
const databaseId=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export function BuildingPhoto({building,name}:{building:string;name:string}) {
 const canView=useCapability('documents:view');
 const canManageDocuments=useCapability('documents:manage'),canManageBuilding=useCapability('property-assets:manage');
 const canUpload=canManageDocuments&&canManageBuilding;
 const[editing,setEditing]=useState(false),[saved,setSaved]=useState(false);
 const [resource,setResource]=useState<Resource>();
 const [revision,setRevision]=useState(0);
 useEffect(()=>{setEditing(false);setSaved(false)},[building]);
 useEffect(()=>{
  const controller=new AbortController();setResource(undefined);
  if(!canView)return()=>controller.abort();
  void api<Result>(withBuildingScope(`/api/property-assets/developments/${building}/primary-image`,building),{signal:controller.signal})
   .then(data=>{if(controller.signal.aborted)return;if(data.building!==building||!(data.image===null||(data.image&&databaseId.test(data.image.documentId)&&databaseId.test(data.image.versionId)&&typeof data.image.title==='string')))throw reviewedApplicationError('The photograph response does not match this building.');setResource({building,data});})
   .catch(error=>{if(!controller.signal.aborted)setResource({building,error});});
  return()=>controller.abort();
 },[building,canView,revision]);
 if(!canView)return null;
 const current=resource?.building===building?resource:undefined;
 const photo=current?.data?.image;

 return <section className="building-photo" aria-label="Building photograph">
  {current?.error?<ErrorState error={current.error} subject="building photograph" headingLevel={3} onRetry={()=>setRevision(value=>value+1)}/>:!current?.data?<State kind="loading" tone="information" heading="Loading building photograph" headingLevel={3} message="Checking the approved primary image."/>:photo?<figure><div className="building-photo__image"><BuildingImage building={{id:building,name,primary_image_document_id:photo.documentId,primary_image_version_id:photo.versionId}}/></div></figure>:<p>No building photo.</p>}
  {canUpload&&current?.data&&!editing&&<button type="button" className="secondary" onClick={()=>{setSaved(false);setEditing(true)}}>{photo?'Change photo':'Add photo'}</button>}
  {editing&&<BuildingPhotoUpload key={building} building={building} version={photo?.versionId} onCancel={()=>setEditing(false)} onSaved={()=>{setEditing(false);setSaved(true);setRevision(value=>value+1)}}/>}
  {saved&&<p role="status">Photo saved.</p>}
 </section>;
}
